"use strict";

exports.__esModule = true;
exports.StripeChartCanvas = void 0;
exports.getBarInset = getBarInset;
var _react = _interopRequireWildcard(require("react"));
var _invariant = _interopRequireDefault(require("invariant"));
var _styledComponents = require("styled-components");
var _vimanaTypes = require("@vimana/vimana-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// Breathing room above and below the bar: 6px, or a tenth of the height when
// that is less, so a short band keeps four fifths of its pixels. The bar
// itself is a rounded track with the segments clipped to it, so the first and
// last segment follow the corners.
var MAX_INSET = 6;
var MAX_INSET_SHARE = 0.1;
var MAX_RADIUS = 5;
var LABEL_PADDING = 6;
var FALLBACK_STYLE = {
  track: "#EFF2F4",
  divider: "rgba(255, 255, 255, 0.7)",
  labelColor: "#ffffff",
  labelFont: '600 10.5px ui-monospace, Menlo, Consolas, "DejaVu Sans Mono", monospace'
};

/** The space the bar leaves above and below itself in a band this tall. */
function getBarInset(height) {
  return Math.max(0, Math.min(MAX_INSET, Math.floor(height * MAX_INSET_SHARE)));
}
function roundedRectPath(context, x, y, width, height, radius) {
  var r = Math.max(0, Math.min(radius, width / 2, height / 2));
  context.beginPath();
  context.moveTo(x + r, y);
  context.lineTo(x + width - r, y);
  context.arcTo(x + width, y, x + width, y + r, r);
  context.lineTo(x + width, y + height - r);
  context.arcTo(x + width, y + height, x + width - r, y + height, r);
  context.lineTo(x + r, y + height);
  context.arcTo(x, y + height, x, y + height - r, r);
  context.lineTo(x, y + r);
  context.arcTo(x, y, x + r, y, r);
  context.closePath();
}

/**
 * A canvas based stripe chart.
 * Does not include an axis or any other functionality.
 */
// eslint-disable-next-line no-shadow
var StripeChartCanvas = exports.StripeChartCanvas = /*#__PURE__*/function (_Component) {
  function StripeChartCanvas() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.registerCanvas = function (canvas) {
      _this.canvas = canvas;
    };
    _this.handleClick = function (e) {
      var _this$props = _this.props,
        scale = _this$props.scale,
        timeline = _this$props.timeline,
        onItemClick = _this$props.onItemClick;
      if (typeof onItemClick !== "function") {
        return;
      }
      var target = e.target;
      var rect = target.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var value = scale.invert(x);
      for (var _iterator = _createForOfIteratorHelperLoose(timeline), _step; !(_step = _iterator()).done;) {
        var item = _step.value;
        var interval = item.interval;
        if (value >= interval.startMillis && value <= interval.endMillis) {
          onItemClick(item);
          return;
        }
      }
    };
    return _this;
  }
  _inheritsLoose(StripeChartCanvas, _Component);
  var _proto = StripeChartCanvas.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var canvas = this.canvas;
    (0, _invariant["default"])(canvas, "Canvas must be present");
    this.draw(canvas);
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    var canvas = this.canvas;
    if (canvas) {
      this.draw(canvas);
    }
  };
  _proto.getStyle = function getStyle() {
    // Theme tokens when a ThemeProvider is present, sensible defaults when not.
    var theme = this.context || {};
    return {
      track: theme.ChartTrackColor || FALLBACK_STYLE.track,
      divider: theme.ChartDividerColor || FALLBACK_STYLE.divider,
      labelColor: theme.ChartLabelColor || FALLBACK_STYLE.labelColor,
      labelFont: theme.ChartFontFamilyMono ? "600 10.5px " + theme.ChartFontFamilyMono : FALLBACK_STYLE.labelFont,
      radius: parseInt(theme.ChartBarRadius, 10) || MAX_RADIUS
    };
  };
  _proto.getBar = function getBar(style) {
    var height = this.props.height;
    var inset = getBarInset(height);
    var barHeight = Math.max(1, height - 2 * inset);
    return {
      top: inset,
      height: barHeight,
      radius: Math.min(style.radius, barHeight / 2)
    };
  };
  _proto.draw = function draw(canvas) {
    var context = canvas.getContext("2d");
    if (!context) {
      return;
    }
    var _this$props2 = this.props,
      timeline = _this$props2.timeline,
      width = _this$props2.width,
      height = _this$props2.height;
    var PIXEL_RATIO = window.devicePixelRatio || 1;

    // scale for PIXEL_RATIO
    canvas.width = width * PIXEL_RATIO;
    canvas.height = height * PIXEL_RATIO;

    // reset transform and set scale for the PIXEL_RATIO
    context.setTransform(PIXEL_RATIO, 0, 0, PIXEL_RATIO, 0, 0);
    context.clearRect(0, 0, width, height);
    var style = this.getStyle();
    var bar = this.getBar(style);

    // The track shows through wherever the timeline has no data.
    context.globalAlpha = 1;
    context.fillStyle = style.track;
    roundedRectPath(context, 0, bar.top, width, bar.height, bar.radius);
    context.fill();
    context.save();
    roundedRectPath(context, 0, bar.top, width, bar.height, bar.radius);
    context.clip();
    var now = Date.now();
    for (var i = 0; i < timeline.length; i++) {
      this.drawValue(context, timeline[i], now, bar, style);
    }
    context.restore();
    context.globalAlpha = 1;
  };
  _proto.drawValue = function drawValue(context, value, now, bar, style) {
    var _this$props3 = this.props,
      getColor = _this$props3.getColor,
      getLabelColor = _this$props3.getLabelColor,
      getCategoryColor = _this$props3.getCategoryColor,
      categoryHeight = _this$props3.categoryHeight,
      getAlpha = _this$props3.getAlpha,
      getLabel = _this$props3.getLabel,
      scale = _this$props3.scale,
      showDivision = _this$props3.showDivision;
    var start = scale(value.interval.startMillis);
    var end = scale(value.interval.endMillis === _vimanaTypes.END_OF_TIME ? now : value.interval.endMillis);
    var width = end - start;
    context.globalAlpha = typeof getAlpha === "function" ? getAlpha(value) : 1;
    context.fillStyle = getColor(value);
    context.fillRect(start, bar.top, width, bar.height);
    if (typeof getCategoryColor === "function" && categoryHeight > 0) {
      var bandHeight = Math.min(categoryHeight, bar.height);
      context.fillStyle = getCategoryColor(value);
      context.fillRect(start, bar.top + bar.height - bandHeight, width, bandHeight);
    }

    // A hairline between segments, the way the design separates blocks.
    if (showDivision && start > 0) {
      context.fillStyle = style.divider;
      context.fillRect(Math.round(start), bar.top, 1, bar.height);
    }
    if (getLabel) {
      var label = getLabel(value);
      if (label) {
        context.font = style.labelFont;
        context.textBaseline = "middle";
        context.fillStyle = typeof getLabelColor === "function" ? getLabelColor(value) : style.labelColor;
        var textWidth = Math.round(context.measureText(label).width);
        if (textWidth + 2 * LABEL_PADDING <= width) {
          context.fillText(label, Math.round(start + width / 2 - textWidth / 2), Math.round(bar.top + bar.height / 2), width);
        }
      }
    }
  };
  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement("canvas", {
      "data-getlabel": this.props.getLabel != null,
      "data-division": this.props.showDivision,
      "data-testid": "StripeChartCanvas",
      "data-timelineValue": JSON.stringify(this.props.timeline),
      ref: this.registerCanvas,
      height: this.props.height,
      width: this.props.width,
      onClick: this.handleClick,
      style: {
        width: "100%",
        height: "100%"
      }
    });
  };
  return StripeChartCanvas;
}(_react.Component);
StripeChartCanvas.contextType = _styledComponents.ThemeContext;
StripeChartCanvas.defaultProps = {
  // A slim band along the bottom of a segment (used to mark user-entered
  // classifications), rather than a block covering most of the bar.
  categoryHeight: 6
};